import { useFileDownload } from '@Hooks/useFileDownload';
import { useDocumentsRepository } from '@Hooks/useRepository';
import { DocumentsRepository } from '@Repositories/Documents';
import { EnumMessageLevel, resolveToBlobResponse, type Result, useToasts } from '@synqo/frontend-component-library';
import { useCallback } from 'react';

/** Hands the result file `fileId` of an export run to the browser. Says why in a toast when it cannot and answers false. */
// @ai-generated 2026-09-29T07:37:25+00:00 by philipp.kammerer@synqony.com using Claude Opus 5.5 (1M context)
export function useExportFileDownload() {
    const documents = useDocumentsRepository(DocumentsRepository);
    const { triggerDownload } = useFileDownload();
    const { pushAllToasts, pushToast } = useToasts();

    const downloadExportFile = useCallback(
        async (fileId: string): Promise<boolean> => {
            const [blob, response] = await documents.downloadFile<[Blob, Response]>(fileId, resolveToBlobResponse);
            if (response.ok) {
                triggerDownload(blob, response);
                return true;
            }

            try {
                const result: Result<unknown> = JSON.parse(await blob.text());
                pushAllToasts(result.messages);
            } catch {
                pushToast({
                    message: 'Unbekannter Fehler beim Download.',
                    title: 'Download',
                    level: EnumMessageLevel.Danger,
                });
            }
            return false;
        },
        [documents, triggerDownload, pushAllToasts, pushToast],
    );

    return { downloadExportFile };
}
